export const Props = () => ({
  //--------------------------------------------------------------------------
  //                            Ссылка на изображение
  //--------------------------------------------------------------------------
  image: {
    type: String,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //--------------------------------------------------------------------------
  //                    Ссылка для переход по клику по блоку
  //--------------------------------------------------------------------------
  link: {
    type: String,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //--------------------------------------------------------------------------
  //                          Дополнительный текст
  //--------------------------------------------------------------------------
  prefix: {
    type: String,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

   //--------------------------------------------------------------------------
  //                              Картинка квадратная?
  //--------------------------------------------------------------------------
  isSquare: {
    type: Boolean,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  
  //--------------------------------------------------------------------------
  //                              Основной текст
  //--------------------------------------------------------------------------
  name: {
    type: String,
    required: false,
  },
});
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
